class StatisticsAdmission {
  constructor() {
    this.alreadyOpened = {};
  }

  tracking() {
    var stats = this;

    if (location.search === "") {
      $(document).on("mousedown", "#main a.button", function (e) {
        uioTrackGAEvent(App.trackingKey, "AdmissionButtonClicked", "forside-" + $(this).text());
        if(window.Statistics != null) {
          Statistics.trackCustomEvent("admission_steps_guide", {
            "step": "ClickedGuideButton"
          });
        }
      });
    } else if (/\?country|\&country/.test(location.search)) {
      if (document.referrer.indexOf(App.pathFrameBuster) != -1) {
        uioTrackGAEvent(App.trackingKey, "AdmissionButtonClicked", "veileder-" + "Show Admission Checklist");
        if(window.Statistics != null) {
          Statistics.trackCustomEvent("admission_steps_guide", {
            "step": "ClickedSubmitGuideFormButton"
          });
        }
      }

      $(document).on("mousedown", ".btn-soknadsweb", function (e) {
        uioTrackGAEvent(App.trackingKey, "AdmissionButtonClicked", "sluttside-" + $(this).text());
        if(window.Statistics != null) {
          Statistics.trackCustomEvent("admission_steps_guide", {
            "step": "ClickedAdmissionExternalButton"
          });
        }
      });
    } else if(/\?guide|\&guide/.test(location.search)) {

    }
  };
}

export default new StatisticsAdmission;
